<template>
  <div style="position: relative;z-index: 1;padding-top:10px;">
    <Tabs type="card" :style="{padding: '0px 0px 0px 0px'}" @on-click="switchCard">
      <TabPane label="涉税同名文件查询" :style="{padding: '0px 10px 0px 10px',overflow:'auto'}">
        <Tree :data="datares" @on-select-change="OnSelectChange" ref="dtree"></Tree>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
// import datatree from '../../static/api/asidetree.json'
import city from '../../components/common/aside/city.vue'
//data
import { mapActions, mapGetters } from 'vuex'
import ConstJson from "../../api/common/constjson.js"
let constJ = new ConstJson()
let parents = null;
export default {
  name: 'IdenticalLeftTree',
  data() {
    return {
      datares: []
    }
  },
  mounted() {
    //this.load_leftree()
    this.load_leftmtree()
    this.init()
  },
  methods: {
    init() {
      let map = []
      var p = { key: 0, value: "税收管理通用规定", id: "001" }
      map.push(p)
      this.$emit("OnSelectChange", map);
    },
    //递归tree
    getParentNode(treeNodes, nodepid) {
      if (!treeNodes || !treeNodes.length) return;
      for (var i = 0; i < treeNodes.length; i++) {
        if (parents && parents.value == nodepid || nodepid == "pptr") {
          return;
        }
        var childs = treeNodes[i].children;
        if (treeNodes[i].value == nodepid) {
          parents = treeNodes[i];
          return;
        }
        if (childs && childs.length > 0) {
          this.getParentNode(childs, nodepid);
        }
      }

    },
    OnSelectChange(data) {
      parents = null;
      if (data[0] == undefined) {
        return;
      }

      if (data.length === 0) {
        return;
      }
      let map = [];
      //map.push({key:"home",value:"Home",id:"0",pid:"0"});
      var item = { key: data[0].nodeKey, value: data[0].title, id: data[0].value };
      if (data[0].pv == "pptr") {
        map.push(item)
      } else {
        //var parent= { key: p_node.nodeKey, value: p_node.title, id: p_node.id};
        while (parents == null || parents.pv != "pptr") //根据用户选择的节点递归父级节点-显示路径
        {
          if (parents == null) {
            this.getParentNode(this.datares, data[0].pv);
          } else {
            this.getParentNode(this.datares, parents.pv);
          }

          var p = { key: parents.nodeKey, value: parents.title, id: parents.value }
          map.push(p)
        }
        map.push(item)
        //console.log(map);
      }

      this.$emit("OnSelectChange", map);
      //data[0].selected = !data[0].selected
    },
    switchCard(name) {
      this.$emit("OnCardSwitch", name);
    },
    //数据访问
    //临时登录
    handle_tmpLogin() {
      //console.log(this.sta.isLogin)
      this.handleTempLogin()
        .then(res => {
          console.log("临时用户登录成功")
          //this.handle_lefttree()
          //console.log(this.sta.isLogin)
        })
        .catch(err => {
          console.log(err)
        })
    },

    // load_leftree(){
    //   if (this.sta.isLogin) {
    //     this.datares=this.sta.initData.leftTree;
    //     //this.handle_lefttree()
    //   }else{
    //     this.handle_tmpLogin()
    //   }
    // },

    load_leftmtree(){
      if (this.sta.isLogin) {

        this.datares=this.sta.initData.leftTMTree;
         console.log(this.sta.initData.leftTMTree)
      }else{
        this.handle_tmpLogin()
      }
    },

    // handle_lefttree() {
    //   constJ.ReqGetLeftTree().then(res => {
    //     if (res.rtncode == 1) {
    //        if(res.rltcode==1){
    //          //resolve(res);
    //          this.datares=res.datas
    //          //console.log(this.datares)
    //          //console.log(JSON.stringify(res.datas))
    //        }else{
    //         //reject(res.rltdesc)
    //        }
    //     }else{
    //       //reject(res.rtndesc)
    //     }
    //   }).catch(err => {
    //     //reject(err)
    //     console.log(err)
    //   })
    // },
    ...mapActions([
      'handleTempLogin' //vuex中定义的actions
    ]),
  },
  computed: {
    ...mapGetters(['sta','isLogin','ltree','ltmtree'])
  },
  components: {
    'CityComponent': city
  },
  watch:{
    // isLogin:function(){
    //   //console.log(this.isLogin)
    //   if(this.isLogin==true)
    //   {
    //     //this.load_leftree()
    //   }
    // },
    ltmtree:function(){
      //onsole.log(this.ltree)
      if(this.isLogin==true)
      {
        this.load_leftmtree()
      }
    },
  }
}

</script>
<style>
</style>
